
import React from "react";
import { Accordion } from "react-bootstrap-accordion";
import "../../components/faq/faq.css"

function NotificationList({ data }) {
    return (
        <section className="FAQ-section notification">
            <div className="container st2">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="accordion-page">
                            <h4>Manage your Notifications</h4>
                            <p className="des">
                                Pellentesque quis lectus sagittis, gravida erat id
                            </p>
                            <h6>Notifications -   {/* <span style={{color:'orange'}}>5New</span> */} </h6>
 

                            {/* ............................................................................... */}
                            {/* Start Notifictions */}
                            {/* ............................................................................... */}

                            {/* 1 */}
                            {/* <div class="flat-accordion"> */}
                            <div class="flat-toggle">
                                <div class="card-container">
                                    <div class="card-header">
                                        <h3 class="title">Ashh</h3>
                                        <span class="show" style={{ color: 'orange' }}> Last Day</span>
                                    </div>
                                    {/* <hr class="middle-line"> */}
                                    <div class="card-content">
                                        <p>Your submit job Graphic Design is <span style={{ color: 'orange' }}>Success</span></p>
                                    </div>
                                </div>
                            </div>
                            {/* </div> */}

                            {/* 2 */}
                            {/* <div class="flat-accordion"> */}
                            <div class="flat-toggle">
                                <div class="card-container">
                                    <div class="card-header">
                                        <h3 class="title">XYZ</h3>
                                        <span class="show" style={{ color: 'orange' }}>5 Days</span>
                                    </div>
                                    {/* <hr class="middle-line"> */}
                                    <div class="card-content">
                                        <p>A new application is submitted on your jobGraphic Design byMaverick Nguyen</p>
                                    </div>
                                </div>
                            </div>
                            {/* </div> */}

                            {/* 3 */}
                            {/* <div class="flat-accordion"> */}
                            <div class="flat-toggle">
                                <div class="card-container">
                                    <div class="card-header">
                                        <h3 class="title">WXY</h3>
                                        <span class="show" style={{ color: 'orange' }}>8 Days</span>
                                    </div>
                                    {/* <hr class="middle-line"> */}
                                    <div class="card-content">
                                        <p>A new application is submitted on your jobGraphic Design byMaverick Nguyen</p>
                                    </div>
                                </div>
                            </div>
                            {/* </div> */}

                            {/* 4 */}
                            {/* <div class="flat-accordion"> */}
                            <div class="flat-toggle">
                                <div class="card-container">
                                    <div class="card-header">
                                        <h3 class="title">Khan</h3>
                                        <span class="show" style={{ color: 'orange' }}>12 Days</span>
                                    </div>
                                    {/* <hr class="middle-line"> */}
                                    <div class="card-content">
                                        <p>Your submit job Graphic Design is <span style={{ color: 'orange' }}>Success</span></p>
                                    </div>
                                </div>
                            </div>
                            {/* </div> */}

                            {/* 4 */}
                            {/* <div class="flat-accordion"> */}
                            <div class="flat-toggle">
                                <div class="card-container">
                                    <div class="card-header">
                                        <h3 class="title">Khan</h3>
                                        <span class="show" style={{ color: 'orange' }}>12 Days</span>
                                    </div>
                                    {/* <hr class="middle-line"> */}
                                    <div class="card-content">
                                        <p>A new application is submitted on your jobGraphic Design byMaverick Nguyen</p>
                                    </div>
                                </div>
                            </div>
                            {/* </div> */}



                            {/* <h6>Suggestion</h6>
              <div className="flat-accordion">
                {data.slice(4, 8).map((item) => (
                  <Accordion
                    key={item.id}
                    title={item.title}
                    show={item.show}
                    className="flat-toggle"
                  >
                    <div className="toggle-content">
                      <p>{item.content}</p>
                    </div>
                  </Accordion>
                ))}
              </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default NotificationList;
